// Manual release marker: update this only when you want to force a new frontend version boundary.
export const APP_VERSION = '2026-06-23T00:00Z_medhugwebsite_glp1_assistant';
